"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.build_data = void 0;
exports.build_data = { "build_version": "3.3.9.4", "build_date": "2025-03-26T18:35:58.417Z", "build_branch": "development", "build_commit": "c5ea4235f1b9fc336a534fc2e13357d1df3256c0" };
//# sourceMappingURL=build_data.js.map